//Erstes element 
import React from "react";

const quotes = [
  "o(*￣︶￣*)o",
  "\(￣︶￣*\))",
  "༼ つ ◕_◕ ༽つ",
  "(‾◡◝)",

];
function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

const Header = () => {
  return (
    <div className="section" id="home">
      <div className="container">
        <div className="header-wrapper">
          <h2>quote of the day :</h2>
          <h2>{quotes[getRandomInt(quotes.length)]}</h2>
          <div className="heading-wrapper"></div>
        </div>
      </div>
    </div>
  );
};

export default Header;
